import { render, staticRenderFns } from "./homework.vue?vue&type=template&id=e747553c&scoped=true"
import script from "./homework.vue?vue&type=script&lang=js"
export * from "./homework.vue?vue&type=script&lang=js"
import style0 from "./homework.vue?vue&type=style&index=0&id=e747553c&prod&lang=less&scoped=true"
import style1 from "./homework.vue?vue&type=style&index=1&id=e747553c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e747553c",
  null
  
)

export default component.exports